export class UserRightsFunctionToUserPrivilegeSetDtoModel {

  //region FIELDS
  userRightsFunctionId: string;
  userPrivilegeSetIds: string[] = [];
  //endregion

}
